type IconProps = {
  size?: number;
  className?: string;
};

const FastingMenuIcon = ({ size = 35, className }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Stabljika */}
      <path d="M12 20V10" />

      {/* Lijevi list */}
      <path d="M12 14c-3 0-5-2-5-5 3 0 5 2 5 5z" />

      {/* Desni list */}
      <path d="M12 11c0-3 2-5 5-5 0 3-2 5-5 5z" />

      {/* Mali list */}
      <path d="M12 17c2.5 0 4.5-1.5 5-4-2.8 0-5 1.8-5 4z" />
    </svg>
  );
};

export default FastingMenuIcon;